var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 31,
    viewBox: "0 0 94 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53795 28.6013C6.62966 29.0756 7.04613 29.4184 7.53075 29.4184H11.0485C11.6069 29.4184 12.0596 28.9672 12.0596 28.4107C12.0596 27.8541 11.6069 27.403 11.0485 27.403H8.36557L8.29862 27.0567H11.6996C12.2461 27.0567 12.6937 26.6239 12.7102 26.0795C12.8197 22.4652 14.2662 20.0955 15.8103 17.6985C15.8697 17.6063 15.9293 17.514 15.9891 17.4214C17.473 15.1234 19.0528 12.6771 19.0528 9.18893C19.0528 6.10483 17.8252 3.77245 15.958 2.22888C14.1165 0.70658 11.7153 0 9.39956 0C4.96113 0 0 3.21599 0 9.29014C0 12.476 1.43898 15.2501 2.82134 17.6249C3.03325 17.989 3.24207 18.3406 3.44552 18.6832C3.92495 19.4905 4.37463 20.2477 4.76504 20.9996C5.31623 22.0612 5.68968 23.0059 5.81027 23.8833C5.87961 24.3877 6.31563 24.7614 6.82646 24.7541C7.33728 24.7468 7.76239 24.3609 7.8172 23.8546C7.90555 23.0387 8.34659 22.0681 9.08049 20.9216C9.70559 19.9451 10.4807 18.9326 11.2999 17.8625C11.4334 17.6881 11.568 17.5122 11.7034 17.3347C12.6521 16.0906 13.6291 14.7746 14.3667 13.4524C15.1011 12.1361 15.6534 10.7189 15.6534 9.27328C15.6534 7.52116 14.9867 6.0326 13.8267 4.99073C12.6774 3.95848 11.1124 3.42432 9.39956 3.42432C6.0206 3.42432 3.39937 6.13209 3.39937 9.27328C3.39937 10.1927 3.58395 11.5728 4.07648 12.76C4.54624 13.8924 5.48747 15.2572 7.18405 15.2572C8.01219 15.2572 8.69054 14.9564 9.19473 14.4493C9.67132 13.9699 9.93962 13.3607 10.0991 12.8031C10.3969 11.7625 10.3949 10.5944 10.3938 9.97912C10.3938 9.94447 10.3937 9.91157 10.3937 9.88054C10.3937 9.32402 9.94104 8.87287 9.38264 8.87287C8.82425 8.87287 8.37158 9.32402 8.37158 9.88054L8.37159 9.92573C8.37171 10.5732 8.37188 11.4909 8.15455 12.2505C8.04559 12.6312 7.90482 12.8834 7.7583 13.0308C7.63938 13.1504 7.48057 13.2418 7.18405 13.2418C6.7835 13.2418 6.33792 12.9367 5.94516 11.9899C5.57516 11.0981 5.42149 9.99011 5.42149 9.27328C5.42149 7.25268 7.12981 5.43967 9.39956 5.43967C10.6971 5.43967 11.7536 5.84171 12.473 6.48789C13.1818 7.12444 13.6313 8.05652 13.6313 9.27328C13.6313 10.223 13.2619 11.2855 12.5994 12.4731C11.9402 13.6548 11.0453 14.867 10.0934 16.1152C9.96322 16.286 9.83175 16.4577 9.69977 16.63C8.88475 17.6942 8.05054 18.7835 7.37574 19.8377C7.19756 20.116 7.02595 20.3986 6.8656 20.6844C6.76793 20.4793 6.66595 20.2756 6.56096 20.0734C6.14265 19.2677 5.64654 18.4322 5.15405 17.6029C4.9572 17.2714 4.76093 16.9409 4.57043 16.6136C3.1961 14.2526 2.02212 11.8902 2.02212 9.29014C2.02212 4.56842 5.82156 2.01535 9.39956 2.01535C11.3288 2.01535 13.2487 2.60765 14.667 3.7801C16.0596 4.93129 17.0307 6.68954 17.0307 9.18893C17.0307 12.0762 15.7442 14.0722 14.2091 16.4538C14.1757 16.5056 14.1422 16.5575 14.1087 16.6097C12.6657 18.8496 11.0899 21.3754 10.7489 25.0414H7.07412C6.77245 25.0414 6.48655 25.1756 6.29448 25.4075C6.10241 25.6393 6.02424 25.9445 6.08132 26.2398L6.53795 28.6013Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7864 29.8529C10.7864 30.7755 10.0651 31 9.17546 31C8.28578 31 7.56456 30.7755 7.56456 29.8529H10.7864Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7309 11.0748C12.8 10.9007 12.7144 10.7036 12.5397 10.6347L11.3292 10.1571C11.1545 10.0882 10.9568 10.1735 10.8876 10.3477C10.8185 10.5218 10.904 10.7189 11.0788 10.7878L12.2893 11.2653C12.464 11.3342 12.6617 11.2489 12.7309 11.0748Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26577 11.3205C6.34395 11.4908 6.54585 11.5657 6.71674 11.4878L7.9006 10.948C8.07149 10.8701 8.14664 10.6689 8.06846 10.4986C7.99028 10.3282 7.78837 10.2533 7.61749 10.3313L6.43363 10.871C6.26274 10.949 6.18759 11.1502 6.26577 11.3205Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05901 9.37312C8.11894 9.19561 8.02313 9.00329 7.84502 8.94356L6.61122 8.52982C6.43311 8.47009 6.24014 8.56558 6.18022 8.74309C6.12029 8.9206 6.21609 9.11293 6.3942 9.17265L7.62801 9.5864C7.80612 9.64612 7.99909 9.55064 8.05901 9.37312Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75362 8.58499C8.92989 8.52006 9.01996 8.325 8.95481 8.14933L8.5032 6.93163C8.43804 6.75595 8.24234 6.66618 8.06607 6.73112C7.88981 6.79605 7.79973 6.9911 7.86489 7.16678L8.3165 8.38448C8.38165 8.56016 8.57736 8.64993 8.75362 8.58499Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0305 8.51843C10.207 8.58287 10.4024 8.49255 10.4671 8.31669L10.9152 7.09774C10.9799 6.92189 10.8893 6.72708 10.7128 6.66264C10.5364 6.5982 10.3409 6.68852 10.2763 6.86438L9.8281 8.08333C9.76344 8.25919 9.85406 8.45399 10.0305 8.51843Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.864 9.28126C10.9449 9.45028 11.148 9.52189 11.3176 9.4412L12.4925 8.88224C12.6621 8.80155 12.7339 8.59912 12.653 8.4301C12.572 8.26108 12.3689 8.18947 12.1993 8.27015L11.0245 8.82912C10.8549 8.90981 10.783 9.11224 10.864 9.28126Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7798 11.5195H25.8289V17.1202H29.2855V18.7395H23.7798V11.5195Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4162 13.1492V18.7395H33.543V18.1413C33.336 18.3682 33.0876 18.5401 32.7979 18.657C32.5081 18.7739 32.2011 18.8324 31.8768 18.8324C31.1524 18.8324 30.5729 18.6192 30.1382 18.1929C29.7104 17.7666 29.4966 17.1271 29.4966 16.2744V13.1492H31.4629V15.9547C31.4629 16.3741 31.5422 16.6801 31.7009 16.8727C31.8596 17.0652 32.0907 17.1615 32.3943 17.1615C32.7047 17.1615 32.9566 17.0549 33.1497 16.8417C33.3498 16.6217 33.4499 16.2882 33.4499 15.8412V13.1492H35.4162Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5233 13.0564C44.2133 13.0564 44.7617 13.2626 45.1688 13.6752C45.5828 14.0878 45.7897 14.7101 45.7897 15.5421V18.7395H43.8234V15.8619C43.8234 15.4699 43.7476 15.1811 43.5958 14.9955C43.4509 14.8098 43.2439 14.717 42.9748 14.717C42.6782 14.717 42.4401 14.8201 42.2608 15.0264C42.0814 15.2327 41.9917 15.5455 41.9917 15.965V18.7395H40.0254V15.8619C40.0254 15.0986 39.7425 14.717 39.1768 14.717C38.8732 14.717 38.6317 14.8201 38.4524 15.0264C38.273 15.2327 38.1833 15.5455 38.1833 15.965V18.7395H36.217V13.1492H38.0901V13.7371C38.2971 13.5102 38.542 13.3417 38.8249 13.2317C39.1147 13.1148 39.4286 13.0564 39.7667 13.0564C40.1599 13.0564 40.5118 13.1286 40.8223 13.273C41.1327 13.4174 41.3845 13.6374 41.5777 13.9331C41.7985 13.6512 42.0779 13.4346 42.416 13.2833C42.7541 13.132 43.1232 13.0564 43.5233 13.0564Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5651 13.1492H48.5314V18.7395H46.5651V13.1492ZM47.5483 12.5303C47.1895 12.5303 46.8997 12.4306 46.6789 12.2312C46.4582 12.0318 46.3478 11.7843 46.3478 11.4886C46.3478 11.1929 46.4582 10.9454 46.6789 10.746C46.8997 10.5466 47.1895 10.4468 47.5483 10.4468C47.907 10.4468 48.1968 10.5431 48.4176 10.7356C48.6383 10.9213 48.7487 11.162 48.7487 11.4576C48.7487 11.7671 48.6383 12.0249 48.4176 12.2312C48.1968 12.4306 47.907 12.5303 47.5483 12.5303Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7341 13.0564C52.6656 13.0564 53.3762 13.2695 53.866 13.6958C54.3559 14.1153 54.6008 14.7617 54.6008 15.6349V18.7395H52.769V18.0175C52.4862 18.5608 51.9342 18.8324 51.1132 18.8324C50.6786 18.8324 50.3026 18.7567 49.9852 18.6055C49.6678 18.4542 49.4263 18.2513 49.2608 17.9969C49.1021 17.7356 49.0227 17.4399 49.0227 17.1099C49.0227 16.5804 49.2263 16.1713 49.6333 15.8825C50.0404 15.5868 50.6682 15.439 51.5168 15.439H52.6345C52.6 14.8476 52.2033 14.5519 51.4444 14.5519C51.1753 14.5519 50.9028 14.5966 50.6268 14.686C50.3508 14.7685 50.1163 14.8854 49.9231 15.0367L49.2608 13.7062C49.5712 13.4999 49.9472 13.3417 50.3888 13.2317C50.8372 13.1148 51.2857 13.0564 51.7341 13.0564ZM51.6617 17.5947C51.8894 17.5947 52.0895 17.5396 52.262 17.4296C52.4344 17.3196 52.5586 17.158 52.6345 16.9449V16.4601H51.7859C51.2133 16.4601 50.9269 16.6492 50.9269 17.0274C50.9269 17.1993 50.9925 17.3368 51.1236 17.4399C51.2547 17.5431 51.434 17.5947 51.6617 17.5947Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5612 18.8839C59.9748 18.8839 59.4056 18.8117 58.8536 18.6673C58.3017 18.5229 57.8533 18.3304 57.5083 18.0897L58.181 16.5839C58.5052 16.797 58.8812 16.9689 59.309 17.0996C59.7368 17.2302 60.1576 17.2955 60.5716 17.2955C61.3581 17.2955 61.7514 17.0996 61.7514 16.7076C61.7514 16.5013 61.6375 16.3501 61.4098 16.2538C61.1891 16.1507 60.8303 16.0441 60.3335 15.9341C59.7885 15.8172 59.3331 15.6934 58.9675 15.5627C58.6018 15.4252 58.2879 15.2086 58.0257 14.9129C57.7636 14.6173 57.6325 14.2184 57.6325 13.7165C57.6325 13.2764 57.7532 12.881 57.9947 12.5303C58.2362 12.1728 58.5949 11.8908 59.071 11.6846C59.5539 11.4783 60.1438 11.3751 60.8406 11.3751C61.3167 11.3751 61.7858 11.4301 62.2481 11.5402C62.7104 11.6433 63.1174 11.798 63.4693 12.0043L62.838 13.5205C62.1481 13.1492 61.4788 12.9635 60.8303 12.9635C60.4232 12.9635 60.1266 13.0254 59.9403 13.1492C59.754 13.2661 59.6609 13.4208 59.6609 13.6133C59.6609 13.8059 59.7713 13.9503 59.992 14.0465C60.2128 14.1428 60.5681 14.2425 61.058 14.3457C61.6099 14.4625 62.0653 14.5898 62.424 14.7273C62.7897 14.8579 63.1036 15.0711 63.3658 15.3668C63.6349 15.6556 63.7694 16.0509 63.7694 16.5529C63.7694 16.9861 63.6487 17.3781 63.4072 17.7287C63.1657 18.0794 62.8035 18.3614 62.3205 18.5745C61.8376 18.7808 61.2512 18.8839 60.5612 18.8839Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0276 18.5126C67.862 18.6158 67.6585 18.6948 67.417 18.7499C67.1824 18.8049 66.9306 18.8324 66.6615 18.8324C65.9302 18.8324 65.3679 18.6536 64.9746 18.296C64.5814 17.9385 64.3848 17.4056 64.3848 16.6973V14.8201H63.5672V13.3555H64.3848V11.9012H66.3511V13.3555H67.6343V14.8201H66.3511V16.6767C66.3511 16.8761 66.4028 17.0342 66.5063 17.1511C66.6167 17.2612 66.7616 17.3162 66.9409 17.3162C67.1686 17.3162 67.3687 17.2577 67.5412 17.1408L68.0276 18.5126Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1933 13.8196C70.3933 13.5652 70.6521 13.3761 70.9694 13.2523C71.2937 13.1217 71.6628 13.0564 72.0768 13.0564V14.8201C71.8974 14.7995 71.749 14.7892 71.6318 14.7892C71.2109 14.7892 70.8797 14.9026 70.6383 15.1295C70.4037 15.3565 70.2864 15.7037 70.2864 16.1713V18.7395H68.3201V13.1492H70.1933V13.8196Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1053 15.9547C78.1053 15.9684 78.0949 16.13 78.0742 16.4395H73.9967C74.0795 16.7283 74.2382 16.9517 74.4728 17.1099C74.7142 17.2612 75.0144 17.3368 75.3731 17.3368C75.6422 17.3368 75.8733 17.299 76.0665 17.2233C76.2666 17.1477 76.4667 17.0239 76.6667 16.852L77.7016 17.9247C77.1566 18.5298 76.3597 18.8324 75.311 18.8324C74.6556 18.8324 74.0795 18.7086 73.5828 18.4611C73.086 18.2135 72.6997 17.8697 72.4237 17.4296C72.1546 16.9895 72.0201 16.491 72.0201 15.9341C72.0201 15.384 72.1512 14.8923 72.4133 14.4591C72.6824 14.019 73.0515 13.6752 73.5207 13.4277C73.9898 13.1801 74.5176 13.0564 75.1041 13.0564C75.6629 13.0564 76.17 13.1733 76.6254 13.407C77.0807 13.634 77.4395 13.9675 77.7016 14.4075C77.9707 14.8407 78.1053 15.3565 78.1053 15.9547ZM75.1144 14.4488C74.8108 14.4488 74.5556 14.5347 74.3486 14.7066C74.1485 14.8786 74.0209 15.1123 73.9657 15.408H76.2631C76.2079 15.1123 76.0769 14.8786 75.8699 14.7066C75.6698 14.5347 75.418 14.4488 75.1144 14.4488Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7851 13.0564C81.7165 13.0564 82.4272 13.2695 82.917 13.6958C83.4069 14.1153 83.6518 14.7617 83.6518 15.6349V18.7395H81.82V18.0175C81.5372 18.5608 80.9852 18.8324 80.1642 18.8324C79.7296 18.8324 79.3535 18.7567 79.0362 18.6055C78.7188 18.4542 78.4773 18.2513 78.3117 17.9969C78.1531 17.7356 78.0737 17.4399 78.0737 17.1099C78.0737 16.5804 78.2772 16.1713 78.6843 15.8825C79.0914 15.5868 79.7192 15.439 80.5678 15.439H81.6855C81.651 14.8476 81.2543 14.5519 80.4954 14.5519C80.2263 14.5519 79.9538 14.5966 79.6778 14.686C79.4018 14.7685 79.1673 14.8854 78.9741 15.0367L78.3117 13.7062C78.6222 13.4999 78.9982 13.3417 79.4398 13.2317C79.8882 13.1148 80.3367 13.0564 80.7851 13.0564ZM80.7127 17.5947C80.9404 17.5947 81.1405 17.5396 81.3129 17.4296C81.4854 17.3196 81.6096 17.158 81.6855 16.9449V16.4601H80.8369C80.2642 16.4601 79.9779 16.6492 79.9779 17.0274C79.9779 17.1993 80.0435 17.3368 80.1746 17.4399C80.3056 17.5431 80.485 17.5947 80.7127 17.5947Z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7336 13.0564C92.4235 13.0564 92.972 13.2626 93.3791 13.6752C93.793 14.0878 94 14.7101 94 15.5421V18.7395H92.0337V15.8619C92.0337 15.4699 91.9578 15.1811 91.806 14.9955C91.6611 14.8098 91.4542 14.717 91.1851 14.717C90.8884 14.717 90.6504 14.8201 90.471 15.0264C90.2916 15.2327 90.2019 15.5455 90.2019 15.965V18.7395H88.2356V15.8619C88.2356 15.0986 87.9528 14.717 87.387 14.717C87.0835 14.717 86.842 14.8201 86.6626 15.0264C86.4832 15.2327 86.3935 15.5455 86.3935 15.965V18.7395H84.4272V13.1492H86.3004V13.7371C86.5074 13.5102 86.7523 13.3417 87.0352 13.2317C87.3249 13.1148 87.6388 13.0564 87.9769 13.0564C88.3702 13.0564 88.722 13.1286 89.0325 13.273C89.343 13.4174 89.5948 13.6374 89.788 13.9331C90.0088 13.6512 90.2882 13.4346 90.6262 13.2833C90.9643 13.132 91.3334 13.0564 91.7336 13.0564Z",
    fill: "url(#paint18_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 7.23266e-8,
    y1: 15.6781,
    x2: 94,
    y2: 15.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTitle);
export default __webpack_public_path__ + "static/media/LogoTitle.166e64829c14422f5a592e31b4cd913a.svg";
export { ForwardRef as ReactComponent };